import { useContext, useMemo, useState } from "react";
import { MdKeyboardArrowDown } from "react-icons/md";
import { AppContext } from "../App";
import logo from "../assets/logo.png";
import { serviceMenuGroups } from "../ones/ServicesContent";

const primaryLinks = [
  { label: "Home", item: "home" },
  { label: "About Us", item: "about_us" },
  { label: "Services", item: "services", hasDropdown: true },
  { label: "Contact Us", item: "contact_us" },
];

export default function TopBar() {
  const appContext = useContext(AppContext);
  const [showServicesMenu, setShowServicesMenu] = useState(false);
  const [activeServiceGroup, setActiveServiceGroup] = useState(
    serviceMenuGroups[0].slug
  );

  const activeItem = useMemo(() => {
    if (!appContext.navItem || appContext.navItem === "home") {
      return "home";
    }

    if (appContext.navItem === "about_us") {
      return "about_us";
    }

    if (appContext.navItem === "contact_us") {
      return "contact_us";
    }

    if (appContext.navItem === "services") {
      return "services";
    }

    return "";
  }, [appContext.navItem]);

  const currentServiceGroup =
    serviceMenuGroups.find((group) => group.slug === activeServiceGroup) ||
    serviceMenuGroups[0];

  function goTo(item) {
    appContext.navTo({ item });
    setShowServicesMenu(false);
  }

  function goToService(slug) {
    appContext.navTo({ item: "services", subItem: slug });
    setShowServicesMenu(false);
  }

  return (
    <header className="TopBar">
      <div className="body">
        <div className="vex-topbar-shell">
          <div className="container">
            <div className="vex-topbar-row vex-topbar-row-top">
              <button
                type="button"
                className="vex-topbar-brand"
                onClick={() => goTo("home")}
              >
                <span className="vex-brand-mark">
                  <img src={logo} alt="VEX logo" />
                </span>
              </button>

              <div className="vex-topbar-title-stack">
                <strong className="vextitle">VEX</strong>
                <span>Supply and Distribution</span>
                <small>Transform people's way of life</small>
              </div>
            </div>
          </div>

          <div className="vex-topbar-row vex-topbar-row-bottom mDesktopOnly">
            <div className="container">
              <nav className="DesktopMenu vex-desktop-nav">
                {primaryLinks.map((link) => {
                  if (link.hasDropdown) {
                    return (
                      <div
                        key={link.item}
                        className="vex-nav-dropdown"
                        onMouseEnter={() => setShowServicesMenu(true)}
                        onMouseLeave={() => setShowServicesMenu(false)}
                        onFocus={() => setShowServicesMenu(true)}
                      >
                        <button
                          type="button"
                          className="vex-nav-link"
                          data-active={activeItem === link.item}
                          onClick={() => goTo(link.item)}
                        >
                          <span>{link.label}</span>
                          <MdKeyboardArrowDown className="vex-nav-caret" />
                        </button>

                        <div
                          className="vex-services-menu"
                          data-open={showServicesMenu}
                        >
                          <div className="vex-services-menu-groups">
                            {serviceMenuGroups.map((group) => (
                              <button
                                key={group.slug}
                                type="button"
                                className="vex-services-menu-group-button"
                                data-active={currentServiceGroup.slug === group.slug}
                                onMouseEnter={() => setActiveServiceGroup(group.slug)}
                                onFocus={() => setActiveServiceGroup(group.slug)}
                                onClick={() => goToService(group.slug)}
                              >
                                <span>{group.menuTitle}</span>
                              </button>
                            ))}
                          </div>

                          <div className="vex-services-menu-panel">
                            <p className="vex-services-menu-panel-label">
                              {currentServiceGroup.title}
                            </p>

                            <div className="vex-services-menu-items">
                              {currentServiceGroup.items.map((item) => (
                                <button
                                  key={`${currentServiceGroup.slug}-${item}`}
                                  type="button"
                                  className="vex-services-menu-item"
                                  onClick={() =>
                                    goToService(currentServiceGroup.slug)
                                  }
                                >
                                  <span>{item}</span>
                                </button>
                              ))}
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  }

                  return (
                    <button
                      key={link.item}
                      type="button"
                      className="vex-nav-link"
                      data-active={activeItem === link.item}
                      onClick={() => goTo(link.item)}
                    >
                      <span>{link.label}</span>
                    </button>
                  );
                })}
              </nav>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}
